module.exports = __webpack_public_path__ + "static/media/FranchiseImage.0f3a62a0.png";